import React from "react";
import { Fab, Box } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";

interface DetailFloatingButtonProps {
  show: boolean;
  onClick: () => void;
}

/**
 * Floating WhatsApp share button
 * - Appears when bottom share bar is hidden (on scroll)
 * - Fixed bottom-right position
 * - Gradient background matching WhatsApp colors
 */
export const DetailFloatingButton: React.FC<DetailFloatingButtonProps> = ({
  show,
  onClick,
}) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1300,
          }}
        >
          <Fab
            color="primary"
            onClick={onClick}
            sx={{
              width: { xs: 56, sm: 64 },
              height: { xs: 56, sm: 64 },
              background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
              boxShadow: "0 8px 24px rgba(37,211,102,0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #128C7E 0%, #075E54 100%)",
                transform: "scale(1.1)",
                boxShadow: "0 12px 32px rgba(37,211,102,0.5)",
              },
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.5,
              }}
            >
              {/* <ShareIcon sx={{ fontSize: { xs: 16, sm: 18 } }} /> */}
              <WhatsApp sx={{ fontSize: { xs: 24, sm: 28 } }} />
            </Box>
          </Fab>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
